var _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeroOrbHollow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 452 901"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.327,
    d: "M264.5 450.5c0 145.255-117.53 263-262.5 263s-262.5-117.745-262.5-263 117.53-263 262.5-263 262.5 117.745 262.5 263z",
    stroke: "#6D7B8E",
    strokeWidth: 5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.176,
    cx: 1.5,
    cy: 450.5,
    r: 448.5,
    stroke: "#6D7B8E",
    strokeWidth: 4
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDUyIiBoZWlnaHQ9IjkwMSIgdmlld0JveD0iMCAwIDQ1MiA5MDEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIG9wYWNpdHk9IjAuMzI3NDI3IiBkPSJNMjY0LjUgNDUwLjVDMjY0LjUgNTk1Ljc1NSAxNDYuOTcgNzEzLjUgMiA3MTMuNUMtMTQyLjk3IDcxMy41IC0yNjAuNSA1OTUuNzU1IC0yNjAuNSA0NTAuNUMtMjYwLjUgMzA1LjI0NSAtMTQyLjk3IDE4Ny41IDIgMTg3LjVDMTQ2Ljk3IDE4Ny41IDI2NC41IDMwNS4yNDUgMjY0LjUgNDUwLjVaIiBzdHJva2U9IiM2RDdCOEUiIHN0cm9rZS13aWR0aD0iNSIvPgo8Y2lyY2xlIG9wYWNpdHk9IjAuMTc2MDg0IiBjeD0iMS41IiBjeT0iNDUwLjUiIHI9IjQ0OC41IiBzdHJva2U9IiM2RDdCOEUiIHN0cm9rZS13aWR0aD0iNCIvPgo8L3N2Zz4K";
export { SvgHeroOrbHollow as ReactComponent };